module.cC({

    name: 'PlacementIndexController',

    inject: ['$scope', 'camelizeFilter', 'educationPlacements', 'jobPlacements'],

    data: {
        placements: "[]",
        forms: "{}",
    },

    init: function() {
        this.placements.push.apply(this.placements, this.educationPlacements);
        this.placements.push.apply(this.placements, this.jobPlacements);
        this.placements.sort(this._placementSortCompare);
    },

    methods: {

        addPlacement: function(placement) {
            this.placements.push(placement);
            this.placements.sort(this._placementSortCompare);
        },

        _getPlacementStartDate: function(placement) {
            return placement.job_start || placement.education_start;
        },

        _placementSortCompare: function(a, b) {
            var a_start = this._getPlacementStartDate(a),
                b_start = this._getPlacementStartDate(b);
            return a_start.diff(b_start) * -1;
        },

        listTemplateName: function(modelName) {
            return 'students/placements/' +
                this.camelizeFilter(modelName) +
                "ListItem";
        },

        openForm: function(type) {
            this.forms[type].open();
        }
    }
});